import { render, staticRenderFns } from "./SimpleChatDarkIcon.vue?vue&type=template&id=64e66571&"
import script from "./SimpleChatDarkIcon.vue?vue&type=script&lang=ts&"
export * from "./SimpleChatDarkIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports